var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.141 5H8.54c-.958.001-1.87.404-2.514 1.11-.645.707-.964 1.651-.877 2.604.413 3.893 1.732 7.618 3.852 10.89 1.922 3.025 4.492 5.596 7.525 7.522 3.25 2.108 6.956 3.427 10.816 3.846.974.088 1.921-.232 2.628-.881.707-.649 1.108-1.565 1.104-2.525V23.96c.043-1.705-1.217-3.192-2.93-3.433-1.09-.144-2.152-.409-3.173-.79l-.209-.07c-1.189-.362-2.49-.046-3.384.838l-.981.98-.117-.071c-2.263-1.438-4.181-3.356-5.619-5.62l-.072-.117.977-.976c.89-.9 1.206-2.207.839-3.401l-.068-.198c-.38-1.02-.645-2.08-.787-3.161C15.31 6.237 13.85 4.983 12.14 5zm-3.6 2h3.62c.706-.007 1.308.51 1.407 1.21.161 1.222.462 2.43.896 3.592.194.517.07 1.097-.316 1.487l-1.525 1.525c-.318.319-.384.81-.162 1.202 1.803 3.17 4.427 5.794 7.597 7.597.392.222.884.156 1.202-.162l1.529-1.53c.386-.381.966-.505 1.48-.312 1.165.435 2.374.736 3.604.898.699.099 1.22.713 1.201 1.427v3.636c.002.4-.164.78-.456 1.047-.292.268-.683.4-1.078.365-3.53-.384-6.94-1.597-9.934-3.539-2.792-1.774-5.153-4.135-6.922-6.92-1.954-3.015-3.167-6.44-3.545-10.005-.034-.377.097-.768.364-1.06C7.769 7.168 8.146 7 8.54 7z",
    transform: "translate(-80 -372) translate(16 298) translate(64 74)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOutline);
export default __webpack_public_path__ + "static/media/call-outline.fcf06b5dc2963d99dd197531c39a3813.svg";
export { ForwardRef as ReactComponent };